module.exports = __webpack_public_path__ + "static/media/Icon-Editor.493038dd.png";